import { database, storage } from "../../config/firebase";
import { selectGroupByKey } from "../selectors/groups";
import { selectUserById } from "../selectors/users";

export const submitGroupCasillas = (
  respuestas,
  currentUser,
  group,
  setStatus,
  pregunta
) => dispatch => {
  const casillaKey = database
    .ref("respuestas")
    .push({
      pregunta,
      respuestas,
      submitUserId: (currentUser && currentUser.uid) || "",
      creationTime: Date.now(),
      tipoActividad: "casillas",
      tipoEntidad: "respuestas",
      nivel: (currentUser && currentUser.nivel) || "",
      submitUserNombre: (currentUser && currentUser.nombre) || "",
      nombreGrupo: (group && group.nombreGrupo) || "",
      groupKey: (group && group.key) || ""
    })
    .getKey();

  database
    .ref("respuestas")
    .child(casillaKey)
    .update({ key: casillaKey });

  setStatus({
    success: `Has enviado la forma correctamente`,
    finishedIcon: true,
    done: true
  });
};

export const submitGroupImageSetRespuesta = (
  groupKey,
  values,
  currentUser,
  setStatus
) => dispatch => {
  const imageSetKey = database
    .ref("respuestas")
    .push({
      groupKey,
      tipoActividad: "imageSet",
      tipoEntidad: "respuestas",
      respuestas: values.respuesta,
      nivel: currentUser.nivel,
      submitUserId: currentUser.uid,
      submitUserNombre: currentUser.nombre || currentUser.name,
      creationTime: Date.now()
    })
    .getKey();

  database
    .ref("respuestas")
    .child(imageSetKey)
    .update({ key: imageSetKey });

  setStatus({
    success: `Has enviado la forma correctamente`,
    finishedIcon: true,
    done: true
  });
};

export const submitGroupUpload = (
  groupKey,
  values,
  currentUser,
  setStatus,
  pregunta
) => dispatch => {
  const uploadKey = database
    .ref("respuestas")
    .push({
      groupKey,
      attachments: values.attachments,
      submitUserId: currentUser.user_id || currentUser.uid,
      nivel: currentUser.nivel,
      creationTime: Date.now(),
      pregunta
    })
    .getKey();

  database
    .ref("respuestas")
    .child(uploadKey)
    .update({ key: uploadKey });

  const storageRef = storage.ref("upload");

  values.attachments.forEach((attachment, i) => {
    const uploadTask =
      attachment[0] &&
      storageRef
        .child(`${groupKey}/${pregunta.numeroPregunta}-${i}`)
        .put(values.attachments[i].mediaLink[0]);

    attachment[0] &&
      uploadTask.on(
        "state_changed",
        function(snapshot) {
          console.log("progress", progress);
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(`Upload is${progress}% done`);
        },
        function(error) {
          console.log(error);
        },
        function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            database
              .ref("respuestas")
              .child(uploadKey)
              .child("media")
              .push({ mediaLink: downloadURL });
          });

          setStatus({
            success: `Has enviado la forma correctamente`,
            finishedIcon: true,
            done: true
          });
        }
      );
  });
};

export const submitGroupTrivia = (
  groupKey,
  values,
  currentUser,
  setStatus,
  correctas,
  pregunta
) => () => {
  const triviaKey = database
    .ref("respuestas")
    .push({
      groupKey,
      respuestas: values,
      submitUserId: currentUser.uid,
      creationTime: Date.now(),
      pregunta
    })
    .getKey();

  database
    .ref("respuestas")
    .child(triviaKey)
    .update({ key: triviaKey });

  setStatus({
    success: `Has enviado la forma correctamente y tienes ${correctas} respuesas correctas`,
    finishedIcon: true
  });
};

export const createActividadesPreguntas = () => dispatch => {
  database
    .ref("viajes")
    .once("value")
    .then(viajesSnapshot => {
      viajesSnapshot.forEach(viajeSnapshot => {
        viajeSnapshot.val().etapas.forEach((etapa, i) => {
          let firebaseActividad = { indexEtapa: i };
          etapa.actividades.forEach((actividad, a) => {
            firebaseActividad = {
              ...firebaseActividad,
              ...actividad,
              indexActividad: a
            };

            if (actividad.tipoActividad === "empty") {
              firebaseActividad = { ...actividad };
            }
            if (actividad.tipoActividad === "transfer") {
              const normTipoActividad = [];
              firebaseActividad = {
                ...firebaseActividad,
                preguntas: normTipoActividad,
                links: null,
                casillas: null,
                trivia: null,
                linkActividad: null
              };

              firebaseActividad = {
                ...firebaseActividad,
                tipoActividad: "transfer",
                links: null,
                casillas: null,
                trivia: null,
                linkActividad: null
              };
            }

            if (actividad.tipoActividad === "link") {
              let normTipoActividad = [];
              actividad.links.forEach((act, l) => {
                normTipoActividad = {
                  ...normTipoActividad,
                  [l]: {
                    descripcion: act.descripcionLink,
                    titulo: act.tituloLink,
                    link: act.link,
                    index: l
                  }
                };
              });

              firebaseActividad = {
                ...firebaseActividad,
                tipoActividad: "links",
                preguntas: normTipoActividad,
                links: null,
                casillas: null,
                trivia: null,
                linkActividad: null
              };
            }

            if (actividad.tipoActividad === "casillas") {
              let normTipoActividad = [];
              actividad.casillas.forEach((act, c) => {
                normTipoActividad = {
                  ...normTipoActividad,
                  [c]: {
                    descripcion:
                      (act.descripcionCasilla && act.descripcionCasilla) || "",
                    titulo: (act.tituloCasilla && act.tituloCasilla) || "",
                    index: c
                  }
                };
                firebaseActividad = {
                  ...firebaseActividad,
                  preguntas: normTipoActividad,
                  links: null,
                  casillas: null,
                  trivia: null,
                  linkActividad: null
                };
              });
            }

            if (actividad.tipoActividad === "trivia") {
              let normTipoActividad = [];
              actividad.trivia &&
                actividad.trivia.forEach((act, t) => {
                  normTipoActividad = {
                    ...normTipoActividad,
                    [t]: {
                      respuestaCorrecta: act.respuestaCorrecta,
                      descripcion: act.descripcionTrivia,
                      titulo: act.tituloTrivia,
                      index: t
                    }
                  };

                  firebaseActividad = {
                    ...firebaseActividad,
                    preguntas: normTipoActividad,
                    links: null,
                    casillas: null,
                    trivia: null,
                    linkActividad: null
                  };
                });
            }

            if (actividad.tipoActividad === "upload") {
              let normTipoActividad = [];
              actividad.upload.forEach((act, u) => {
                normTipoActividad = {
                  ...normTipoActividad,
                  [u]: {
                    descripcion:
                      (act.uploadDescription && act.uploadDescription) || "",
                    titulo: act.uploadTitle,
                    index: u
                  }
                };
                firebaseActividad = {
                  ...firebaseActividad,
                  preguntas: normTipoActividad,
                  links: null,
                  casillas: null,
                  trivia: null,
                  linkActividad: null
                };
              });
            }

            const actividadKey = database
              .ref("preguntas")
              .push({
                ...firebaseActividad,
                tipoEntidad: "pregunta",
                indexEtapa: i,
                indexActividad: a,
                nivel: viajeSnapshot.val().nivel,
                nombreEtapa: etapa.nombreEtapa
              })
              .getKey();

            database
              .ref("preguntas")
              .child(actividadKey)
              .update({ key: actividadKey });
          });
        });
      });
    });

  database
    .ref("creatorActividades")
    .once("value")
    .then(actividadesSnapshot => {
      actividadesSnapshot.forEach(actividadSnapshot => {
        const actividad = actividadSnapshot.val();
        const preguntasActividad = actividad[actividad.tipoActividad];
        let firebaseActividad = {};
        let normTipoActividad = {};

        Object.keys(preguntasActividad).forEach((act, i) => {
          normTipoActividad = {
            ...normTipoActividad,
            [i]: {
              titulo:
                (preguntasActividad[act].imageSetLink &&
                  preguntasActividad[act].imageSetLink) ||
                ""
            }
          };

          firebaseActividad = {
            ...actividad,
            descripcion: (actividad.description && actividad.description) || "",
            titulo: (actividad.title && actividad.title) || "",
            preguntas: normTipoActividad,
            viajeId: null,
            title: null,
            description: null,
            imageSet: null
          };
        });

        database
          .ref("preguntas")
          .child(actividadSnapshot.key)
          .set({ ...firebaseActividad });
      });
    });
};

export const createActividadesRespuestas = () => (dispatch, getState) => {
  database
    .ref("actividades")
    .once("value")
    .then(activityKindSnapshot => {
      activityKindSnapshot.forEach(actividadesSnapshoot => {
        actividadesSnapshoot.forEach(actividadSnapshot => {
          const respuesta = actividadSnapshot.val();
          const actividadGroup = selectGroupByKey(
            getState(),
            actividadSnapshot.val().groupKey
          );
          const actividadUser = selectUserById(
            getState(),
            actividadSnapshot.val().submitUserId
          );
          const respuestaKey = actividadSnapshot.key;

          database
            .ref("respuestas")
            .child(respuestaKey)
            .set({
              ...actividadSnapshot.val(),
              tipoActividad:
                actividadesSnapshoot.key === "trivias"
                  ? actividadesSnapshoot.key.slice(0, -1)
                  : actividadesSnapshoot.key,
              tipoEntidad: "respuesta",
              nivel:
                (actividadUser && actividadUser.nivel) ||
                (actividadGroup && actividadGroup.nivel),
              submitUserColegio: (actividadUser && actividadUser.colegio) || "",
              submitUserNombre: (actividadUser && actividadUser.nombre) || "",
              nombreGrupo: (actividadGroup && actividadGroup.nombreGrupo) || "",
              actividadId: null,
              etapaId: null,
              viajeId: null
            });
        });
      });
    });
};

export const addActividadToRespuestas = () => {
  database.ref("viajes").once("value", viajesSnapshot => {
    viajesSnapshot.forEach(viajeSnapshot => {
      const viaje = viajeSnapshot.val();
      viajeSnapshot.val().etapas.forEach((etapaSnapshot, etapaIndex) => {
        etapaSnapshot.actividades.forEach((actividad, actividadIndex) => {
          database.ref("respuestas").once("value", respuestasSnapshot => {
            respuestasSnapshot.forEach((rSnapshot, i) => {
              const respuesta = rSnapshot.val();
              if (
                respuesta.nivel === viaje.nivel &&
                actividad.tipoActividad === respuesta.tipoActividad
              ) {
                database
                  .ref("respuestas")
                  .child(respuesta.key)
                  .update({ etapaIndex, actividadIndex });
              }
            });
          });
        });
      });
    });
  });
};
